/**
 * Global Ad Media Manager
 * Ensures only one audio/video ad plays at a time
 * Manages visibility-based autoplay
 */

class AdMediaManager {
  constructor() {
    this.currentlyPlayingAudioId = null;
    this.currentlyPlayingVideoId = null;
    this.audioListeners = new Map();
    this.videoListeners = new Map();
  }

  // Register an audio ad
  registerAudio(id, callbacks) {
    this.audioListeners.set(id, callbacks);
  }

  // Unregister an audio ad
  unregisterAudio(id) {
    this.audioListeners.delete(id);
    if (this.currentlyPlayingAudioId === id) {
      this.currentlyPlayingAudioId = null;
    }
  }

  // Request to play audio - stops any other playing audio first
  requestAudioPlay(id) {
    // Stop currently playing audio if different
    if (this.currentlyPlayingAudioId && this.currentlyPlayingAudioId !== id) {
      const currentCallbacks = this.audioListeners.get(this.currentlyPlayingAudioId);
      if (currentCallbacks && currentCallbacks.onForceStop) {
        console.log(`🔇 Stopping audio ad: ${this.currentlyPlayingAudioId}`);
        currentCallbacks.onForceStop();
      }
    }
    this.currentlyPlayingAudioId = id;
    console.log(`🔊 Now playing audio ad: ${id}`);
    return true;
  }

  // Notify that audio stopped
  notifyAudioStopped(id) {
    if (this.currentlyPlayingAudioId === id) {
      this.currentlyPlayingAudioId = null;
    }
  }

  // Register a video ad
  registerVideo(id, callbacks) {
    this.videoListeners.set(id, callbacks);
  }

  // Unregister a video ad
  unregisterVideo(id) {
    this.videoListeners.delete(id);
    if (this.currentlyPlayingVideoId === id) {
      this.currentlyPlayingVideoId = null;
    }
  }

  // Request to unmute video - mutes any other unmuted video first
  requestVideoUnmute(id) {
    // Mute currently unmuted video if different
    if (this.currentlyPlayingVideoId && this.currentlyPlayingVideoId !== id) {
      const currentCallbacks = this.videoListeners.get(this.currentlyPlayingVideoId);
      if (currentCallbacks && currentCallbacks.onForceMute) {
        console.log(`🔇 Muting video ad: ${this.currentlyPlayingVideoId}`);
        currentCallbacks.onForceMute();
      }
    }
    this.currentlyPlayingVideoId = id;
    console.log(`🔊 Unmuting video ad: ${id}`);
    return true;
  }

  // Notify that video was muted
  notifyVideoMuted(id) {
    if (this.currentlyPlayingVideoId === id) {
      this.currentlyPlayingVideoId = null;
    }
  }
}

// Singleton instance
const adMediaManager = new AdMediaManager();
export default adMediaManager;
